import React,{useState, useEffect,useReducer} from 'react';
import './css/Login.css';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword} from 'firebase/auth';
import { db } from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc, setDoc } from 'firebase/firestore';
import { AnimatePresence, motion } from 'framer-motion';
import {Link, useNavigate} from "react-router-dom" ;
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn";

import NoUserFoundPopup from './NoUserFoundPopup';

const Login = React.memo(props => {
    const auth = getAuth();
    const user = auth.currentUser;
    let navigate = useNavigate();
    let dispatch = useDispatch();



    ///////if youre already logged in, go to the home page
    const URL = window.location.href;


    //const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userID, setUserID] = useState(''); 
    const [loggedInCookie, setLoginCookieStatus] = useState(window.localStorage.getItem('loggedIn')); 


    const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
    const reduxUserName = useSelector((state) => state.isLoggedIn.reduxUserName);
    const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);
    const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);

    const [emailPlaceHolder, setEmailPlaceHolder] = useState('email');
    const [passwordPlaceHolder, setPasswordPlaceHolder] = useState('password');

    const [buttonLoading, setButtonLoading] = useState(false);
    const [noUserPopup, setNoUserPopup] = useState(false);

    //using useReducer() bc we have to update multiple properties at once
    function missingReducer(signupMissing,action){
        switch(action.type){
             case 'userName':{ return{ ...signupMissing, userName: action.payload.userName} }
             case 'email':{ return{ ...signupMissing, email: action.payload.email} }
             case 'password':{ return{ ...signupMissing, password: action.payload.password} }   
        }
    }
   //when using reducers, this is how to set up the 'state'
   const [signupMissing, dispatchMissing] = useReducer(missingReducer, {userName:false, email:false, password:false});   

    

    /////get a single document 'headshot'
    const headShotGrab = () =>{
        const userHeadshotRef = doc(db,"users",reduxUserID);
        getDoc(userHeadshotRef)
        .then(function(dataReturned){
            
            if(dataReturned.data().headshot != undefined && dataReturned.data().headshot != '' && dataReturned.data().headshot != null){
                console.log(dataReturned.data().headshot);
                dispatch(setPhoto(dataReturned.data().headshot)); 
            }
            else{
                dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg")); 
            }  
        })
    }



    useEffect(() => {


      }, [reduxUserID])



    const logIn = () => {

        //check for missing values
        if(email == ''){ 
            dispatchMissing({type:'email', payload:{email:true}}) 
            setEmailPlaceHolder("Enter an Email"); 
            
        }
        if(password == ''){ 
            dispatchMissing({type:'password', payload:{password:true}});
            setPasswordPlaceHolder("Enter a Password"); 
            
        }

        if(email == '' && password == ''  ){
            return;
        }

        //if the email is missing a '@', let the person know
        if( email.indexOf('@') == -1 && email != ''){ 
            setEmail('');
            setEmailPlaceHolder("You entered an invalid email address");
        }
        
        setButtonLoading(true);
        


        //from firebase
        signInWithEmailAndPassword(auth,email,password)
        .then( (cred)=> {
            console.log('user logged in: ', cred.user);
            setUserID(cred.user.uid);
            setLoginCookieStatus(true);

            
            //localStorage
            window.localStorage.setItem('loggedIn', true);
            window.localStorage.setItem('username', cred.user.displayName);
            window.localStorage.setItem('userPhoto', "http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg");
            window.localStorage.setItem('userID', cred.user.uid);           
            
            //redux
            dispatch(setLoginStatus(true));
            dispatch(setReduxUserID(cred.user.uid));
            dispatch(setUserName(cred.user.displayName));
            dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg")); //first set redux photo to this
            headShotGrab();  // then set it to the DB image if there is one
            
            navigate("/app/home");
        })
        .catch( (err) =>{
            setButtonLoading(false);
            console.log(err.message);

            if( email.indexOf('@') == -1 || email.indexOf('.') == -1 ){ 
                dispatchMissing({type:'email', payload:{email:true}}) 
                setEmailPlaceHolder("You entered an invalid email address");
                setEmail('');
                return;
            }   
            
            /////if there's something wrong with the email
            else if( err.message.indexOf('auth/invalid-email') != -1 ){ 
                dispatchMissing({type:'email', payload:{email:true}}) 
                setEmail('');
                setEmailPlaceHolder("You entered an invalid email address");
                return;
            }    
            
            /////if there's something wrong with the email
            else if( err.message.indexOf('auth/wrong-password') != -1 ){ 
                setPassword('');
                dispatchMissing({type:'password', payload:{password:true}}); 
                setPasswordPlaceHolder("You entered an incorrect password"); 
                return;
            }    

            /////if there's no user that matches the entered data
            else if( err.message.indexOf('auth/user-not-found') != -1 ){ 
               setNoUserPopup(true);
            }


        })//end catch()
    } //end LOGIN()


    const emailFocus = () => {
        dispatchMissing({type:'email', payload:{email:false}}); 
        setEmailPlaceHolder('email')
    }

    const passwordFocus = () => {
        dispatchMissing({type:'password', payload:{password:false}}); 
        setPasswordPlaceHolder("password"); 
    }

    const closeNoUserPopup = () => {
        setNoUserPopup(false);
    }




    return (

        <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{duration:0.2}}>
            <div className='LoginContainer'>

                {noUserPopup &&
                    <NoUserFoundPopup email={email} setNoUserPopup={setNoUserPopup} message={"noUser"} />
                }

                <div className='imageArea'></div>
                <div className='formContainer'>
                    
                    <h1 className='loginTitle'>Log-in</h1>

                    {/*
                    <div className='loginLabel'>Username</div>
                    <input type='text' value={userName} placeholder="username" className='userName'
                        onChange = {(event) => setUserName(event.target.value)} 
                    // onKeyPress={enterPressHack}
                    /> 
                    */}

                    <div className='loginLabel'>Email</div>
                    <input 
                        type='text' 
                        value={email} 
                        placeholder={ emailPlaceHolder }
                        className={ signupMissing.email ? 'email loginMissing' : 'email'}
                        onChange = {(event) => setEmail(event.target.value)} 
                        onFocus = { emailFocus }

                    />

                    <div className='loginLabel'>Password</div>
                    <input 
                        type='password' 
                        value={password} 
                        placeholder={ passwordPlaceHolder }
                        className={ signupMissing.password ? 'password loginMissing' : 'password '}
                        onChange = {(event) => setPassword(event.target.value)} 
                        onFocus = { passwordFocus }

                    />

                    <div className='buttonArea'>
                        {buttonLoading &&
                            <div className='singupButtonLoadingArea'>
                                <div className='singupButtonLoading'></div>
                            </div>
                        }
        
                         <button className='loginButton' onClick={ logIn }>Login</button>    
                        
                    </div>

                    <div className='buttonArea'>
                        <p>Don't have an account?  
                            <Link className='signUpLink' to="/app/signup">Sign Up</Link>
                        </p>
                    </div>
                </div>{/* end formContainer */}

            {/* end formContainer */}
            </div> 
        </motion.div>
    )
})

export default Login
